export enum EContentType {
  Document = 'document',
  Course = 'course',
  Collection = 'collection',
  All = 'all',
}

export enum EContentVisibility {
  Private = 'Private',
  Public = 'Public',
}

export enum ECollectionStatus {
  Draft = 'Draft',
  Published = 'Published',
  Editing = 'Editing',
  Hidden = 'Hidden',
}

export enum ECourseStatus {
  Draft = 'Draft',
  Published = 'Published',
  Hidden = 'Hidden',
}

export interface ICategory {
  id: number;
  name: string;
  categories: ICategory[];
}

export interface IMaterialDetail {
  metadata: {
    extension: string;
  };
  id: string;
  name: string;
  owner: {
    avatar: string;
    id: string;
    name: string;
    profileUrl: string;
    academicRank: string;
  };
  thumbnailUrl: string;
}

export interface IResponseDetailMaterial {
  material: {
    category: {
      category: IResponseDetailMaterial['material']['category'] | null;
      id: number;
      name: string;
    };
    description: string;
    id: string;
    isOwner: boolean;
    metadata: {
      error: null;
      extension: string;
      fileName: string;
      pageCount: number;
      size: number;
    };
    name: string;
    owner: {
      avatar: string;
      academicRank: null;
      id: string;
      name: string;
      profileUrl: string;
    };
    thumbnailUrl: string;
    url: string;
    visibility: EContentVisibility;
  };
}

export interface ICreateContentLink {
  authorName: string;
  authorUrl: string;
  name: string;
  url: string;
}

export interface IUpdateContentLink extends ICreateContentLink {
  contentLinkId: string;
}
